import { createFileRoute } from '@tanstack/react-router';

import { ProfileView } from '@/platform/profile/ProfileView';

export const Route = createFileRoute('/_app/profile')({
   component: ProfileView
});
